var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('img',{staticClass:"theme-day",attrs:{"alt":"dApp logo","src":_vm.light}}),_c('img',{staticClass:"theme-night",attrs:{"alt":"dApp logo","src":_vm.dark}})])}
var staticRenderFns = []

export { render, staticRenderFns }